export default __webpack_public_path__ + "static/media/pune.54b8378c.jpg";